import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { EnterButton } from '@backrs_ui/grow-ui/src/components/Lubav/EnterButton';
import { SolutionSessionMessageType } from '@backrs_ui/grow-ui/src/models/models';
import { useAppDispatch, useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  getSessionState,
  getActiveLubavSession,
  createSessionAction,
} from '@backrs_ui/grow-ui/src/redux/lubavSessionState/lubavSessionState.utils';
import { setUserInput } from '@backrs_ui/grow-ui/src/redux/solutionSession/solutionSession';

const QUESTION_STRINGS = appStrings.modules.solutionSessions.questions;

type SubmitButtonProps = Readonly<{
  type: SolutionSessionMessageType;
  sendQAMessage: (message: string, LLMInput?: string) => void;
  required: boolean;
  selectedOptions: string[];
  setSelectedOptions: (options: string[]) => void;
}>;

export const SubmitButton = ({
  type,
  sendQAMessage,
  required,
  selectedOptions,
  setSelectedOptions,
}: SubmitButtonProps) => {
  const dispatch = useAppDispatch();
  const activeSession = useAppSelector(getActiveLubavSession);
  const { userMessage, userInput } = useAppSelector(
    (state) => getSessionState(state, activeSession).solutionSession,
  );

  if (!activeSession) {
    return null;
  }

  const isDisabled =
    (type === 'multi_select' && selectedOptions.length === 0) ||
    (userInput?.type === 'SINGLE_INPUT' && !userInput.value.trim() && required) ||
    (userInput?.type === 'MULTIPLE_INPUT_MAP' &&
      Object.keys(userInput.value).length === 0 &&
      required);

  const handleSubmit = () => {
    if (userInput?.type === 'SINGLE_INPUT' && !userInput.value.trim() && required) {
      return;
    }
    if (
      userInput?.type === 'MULTIPLE_INPUT_MAP' &&
      Object.keys(userInput.value).length === 0 &&
      required
    ) {
      return;
    }

    if (userInput?.type === 'MULTIPLE_INPUT' && userInput.value.length > 0) {
      sendQAMessage(userInput.value.join(', '), userMessage);
    }

    if (userInput?.type === 'MULTIPLE_INPUT_MAP') {
      const formattedObject = Object.entries(userInput.value)
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ');

      sendQAMessage(formattedObject, userMessage);
    }

    if (userInput?.type === 'SINGLE_INPUT') {
      sendQAMessage(userInput.value, userMessage);
    }

    setSelectedOptions([]);
    dispatch(createSessionAction(setUserInput, activeSession)(undefined));
  };

  return (
    <EnterButton
      onClick={handleSubmit}
      label={QUESTION_STRINGS.submit}
      showEnterHint={true}
      disabled={isDisabled}
    />
  );
};
